import React from 'react'

function Footer(props) {


  return (
    <div className={"bg-white text-gray-800 p-6 pt-24 text-center text-sm " + props.transition}>
  &copy; <span className="roboto-slab-ttl">AF FILMS</span> 2025 &bull; <a className="link" href="/legal">Legal</a> <br/> <a style={{color:'#666',letterSpacing: '0.2px'}} className="text-sm pb-2 pt-2.5" href="https://remiblot.com">Crafted by Rémi Blot</a>
  <br/>

</div>
  )
}

export default Footer
